import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the large plugin icon
 * 
 * @param {Object} props - The props of the component
 * @returns The large plugin icon
 */
const LargePluginIcon = (props) => (
  <Icon viewBox="0 0 40 40" fill="none" {...props}>
    <rect x="18" y="6" width="16" height="28" rx="2" stroke="currentColor" strokeWidth="2" />
  </Icon>
);

export default React.memo(LargePluginIcon);
